module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1268.3c6fd79c.png";